import { useMutation } from "@tanstack/react-query"
import { useSelector } from "react-redux"
import { sendMessageFetch } from "store/middlewares/messages.crud"
import { isValid, submit } from "redux-form"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"
import { toastConfig } from "config"
import constants from './constants'
import { MessageRM } from "models/RM"
import { useLocation } from "react-router-dom"
import { replaceId } from "utils/formatter"

const useSubmitBtn = () => {
    const { formname } = constants
    const dispatch = useDispatch()
    const location = useLocation()

    const formValues = useSelector(state => state.form[formname]?.values)
    const isFormValid = useSelector(state => isValid(formname)(state));

    const screenNames = {
        "/home": "דשבורד",
        "/users": "משתמשים",
        "/test-takers": "תלמידים",
        "/all-assessments": "אבחונים פעילים",
        "/assessments": "דוחות",
        "/assessments/id": "דוח אישי",
        "/matching-learning/id": "למידה מותאמת",
        "/contact-us": "צור קשר",
        "defualt": "אחר"
    }

    const { mutateAsync: sendMessage, isPending: sendMessageLoading } = useMutation({
        mutationFn: sendMessageFetch,
        onSuccess: () => {
            toast("פנייתכם התקבלה בהצלחה", toastConfig)
        }
    })

    const postMessage = async () => {
        if (isFormValid) {
            const routeName = replaceId(location.pathname, "id")
            console.log("routeName", routeName)
            const message = new MessageRM({ ...formValues, screen_name: screenNames[routeName] })
            const data = await sendMessage(message)
            return data
        }
        else {
            dispatch(submit(formname))
            return false
        }
    }

    const submitBtn = {
        label: "שליחה",
        action: postMessage,
        color: "secondary",
        fullWidth: true,
        loading: sendMessageLoading,
        disabled: sendMessageLoading
    }

    return submitBtn
}

export default useSubmitBtn


